<template>
    <div class="buttons">
        <div class="button-controls d-flex justify-space-between">
            <v-btn prepend-icon="mdi-printer" @click="printPage">Print</v-btn>
        </div>
    </div>
    <div class="book">
        <div class="page">
            <div class="subpage">
                <v-overlay :model-value="loading"
                           class="align-center justify-center">
                    <v-progress-circular color="primary"
                                         indeterminate
                                         size="64"></v-progress-circular>
                </v-overlay>
                <div v-if="data">
                    <div class="d-flex justify-space-between align-center mb-2">
                        <h3>{{ data.contactName }} — Active Jobs</h3>
                        <small style="color: #757575;">{{ currentDate }}</small>
                    </div>

                    <v-sheet class="mb-3" rounded>
                        <h4 class="mb-1"><v-icon icon="mdi-calendar-check" class="mr-1"></v-icon>SCHEDULED</h4>
                        <v-table density="compact" class="run-table">
                            <thead>
                                <tr>
                                    <th style="width:15%">#</th>
                                    <th style="width:45%">Customer Ref</th>
                                    <th style="width:25%">Colours</th>
                                    <th style="width:15%" class="text-right">Sch. Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="job in scheduledJobs" :key="job.id">
                                    <td>{{ job.internalNumber }}</td>
                                    <td>{{ job.customerNumber }}</td>
                                    <td>{{ job.colours }}</td>
                                    <td class="text-right">{{ formatDate(job.scheduledDate) }}</td>
                                </tr>
                                <tr v-if="scheduledJobs.length === 0">
                                    <td colspan="4" class="text-center text-medium-emphasis">No scheduled jobs</td>
                                </tr>
                            </tbody>
                        </v-table>
                    </v-sheet>

                    <v-sheet rounded>
                        <h4 class="mb-1"><v-icon icon="mdi-calendar-question" class="mr-1"></v-icon>UNSCHEDULED</h4>
                        <v-table density="compact" class="run-table">
                            <thead>
                                <tr>
                                    <th style="width:15%">#</th>
                                    <th style="width:45%">Customer Ref</th>
                                    <th style="width:25%">Colours</th>
                                    <th style="width:15%" class="text-right">Created</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="job in unscheduledJobs" :key="job.id">
                                    <td>{{ job.internalNumber }}</td>
                                    <td>{{ job.customerNumber }}</td>
                                    <td>{{ job.colours }}</td>
                                    <td class="text-right">{{ formatDate(job.dateCreated) }}</td>
                                </tr>
                                <tr v-if="unscheduledJobs.length === 0">
                                    <td colspan="4" class="text-center text-medium-emphasis">No unscheduled jobs</td>
                                </tr>
                            </tbody>
                        </v-table>
                    </v-sheet>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
    @import '../styles/portraitprint.scss';
    .book {
        margin-top: 140px;
    }
    .run-table {
        font-size: 11px;
    }
    .v-table--density-compact > .v-table__wrapper > table > tbody > tr > td,
    .v-table--density-compact > .v-table__wrapper > table > tbody > tr > th {
        height: 20px !important;
    }
    @media print {
        .book {
            margin-top: 0px;
            margin-bottom: 0px;
            background-color: white;
        }
        #app html body .v-application__wrap {
            background-color: white;
        }
        .page {
            min-height: auto;
            padding-top: 5px;
        }
    }
</style>
<script>
    import { mapActions } from "vuex";
    import { numberWithCommas } from "../mixins/numberMixins";
    export default {
        name: "CustomerRunSheet",
        props: {
            id: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                loading: false,
                data: null,
            };
        },
        mounted() {
            this.loadData();
        },
        methods: {
            ...mapActions(['showErrorSnack']),
            numberWithCommas,
            printPage() {
                var css = '@page { size: A4 portrait!important; }',
                    head = document.head || document.getElementsByTagName('head')[0],
                    style = document.createElement('style');
                style.type = 'text/css';
                style.media = 'print';
                if (style.styleSheet) {
                    style.styleSheet.cssText = css;
                } else {
                    style.appendChild(document.createTextNode(css));
                }
                head.appendChild(style);
                window.print();
            },
            loadData() {
                this.loading = true;
                this.$api.get(`contacts/${this.id}/runsheet`)
                    .then(res => {
                        this.loading = false;
                        this.data = res.data;
                    }).catch(() => {
                        this.loading = false;
                        this.showErrorSnack("There was an issue loading the run sheet");
                    });
            },
            formatDate(date) {
                if (!date) return '';
                return this.$dayjs(date).format('DD/MM/YYYY');
            },
        },
        computed: {
            currentDate() {
                return this.$dayjs().format('D MMMM YYYY');
            },
            scheduledJobs() {
                if (!this.data) return [];
                return this.data.jobs
                    .filter(j => j.scheduledDate)
                    .sort((a, b) => new Date(a.scheduledDate) - new Date(b.scheduledDate));
            },
            unscheduledJobs() {
                if (!this.data) return [];
                return this.data.jobs
                    .filter(j => !j.scheduledDate)
                    .sort((a, b) => new Date(a.dateCreated) - new Date(b.dateCreated));
            },
        }
    };
</script>
